import { render, staticRenderFns } from "./MonthlyTotalEmissionsBarGraph.vue?vue&type=template&id=5a18fca2"
import script from "./MonthlyTotalEmissionsBarGraph.vue?vue&type=script&lang=js"
export * from "./MonthlyTotalEmissionsBarGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports